<template>
  <div>
    <!-- 司机信息 -->
    <Card title="司机信息">
      <div v-if="center" class="driver-info">
        <div class="driver-info-item" v-for="item in driverList" :key="item.name">
          {{ item.name }}:{{ driverSource[item.key] || '--' }}
        </div>
      </div>
      <QS-column-box
        v-else
        :source="driverSource"
        :column="2"
        :list="driverList"
        separator=":"
      />
    </Card>
  </div>
</template>
<script setup>
defineProps({
  // 司机信息
  driverSource: {
    type: Object,
    default: () => ({
      driverName: '',
      mobile: '',
      idCard: '',
      carNumber: '',
    }),
  },
  // 居中布局
  center: {
    type: Boolean,
    default: false,
  },
})

const driverList = [
  {
    name: '司机姓名',
    key: 'customerName',
  },
  {
    name: '身份证号',
    key: 'idCardNo',
  },
  {
    name: '手机号',
    key: 'customerTel',
  },
  {
    name: '车牌号',
    key: 'plateNo',
  },
]
</script>
<style lang="scss" scoped>
.driver-info {
  margin-left: 100px;
  margin-right: 100px;
  display: flex;
  flex-wrap: wrap;
  .driver-info-item {
    width: 50%;
    margin-bottom: 16px;
    box-sizing: border-box;
    color: #303133;
  }
}
</style>
